<template>
  <section
    v-if="!data.hide"
    class="tw-text-center jwb-module big-icons [&_svg]:tw-w-[75px] [&_svg]:md:tw-w-[150px]"
    :class="sectionClasses"
  >
    <div class="container">
      <h2 v-if="data.includeTitle" class="heading">{{ data.sectionTitle }}</h2>
      <ul class="re-li">
        <li v-for="item in data.list" :key="item.id">
          <a :href="item.link" :aria-label="item.label">
            <div class="icon" v-html="item.icon"></div>
            <div class="title">{{ item.label }}</div>
          </a>
        </li>
      </ul>
      <div v-if="data.includeButton" class="button-block">
        <a class="jwb-button" :href="data.buttonLink">{{ data.buttonText }}</a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'BigIconsSection',
  props: {
    data: Object,
  },
  computed: {
    sectionClasses() {
      return {
        'blue-background': this.data.backgroundOption,
        'has-title': this.data.includeTitle,
      }
    },
  },
}
</script>
